import { render } from "./Branches.vue?vue&type=template&id=b6c4ed68&scoped=true"
import script from "./Branches.vue?vue&type=script&lang=js"
export * from "./Branches.vue?vue&type=script&lang=js"

import "./Branches.vue?vue&type=style&index=0&id=b6c4ed68&scoped=true&lang=css"
import "./Branches.vue?vue&type=style&index=1&id=b6c4ed68&lang=css"

import exportComponent from "C:\\Askar\\personalArea\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6c4ed68"]])

export default __exports__